import {observer} from 'mobx-react-lite'
import appStore from '../../../storage/AppStore'
import Btn from '../../../ui/Btn'
import clubStore from '../../../storage/ClubStore'
import {useNavigate} from 'react-router-dom'

const Child = ({child, url_base}) => {
  const navigate = useNavigate();
  return (
    <div
      className="col-12 md:col-6 lg:col-4"
      key={child.id}
    >
      <div className="card shadow-3 h-full children-card">
        
        {/* Photo */}
        <div className="children-card-photo">
          <img
            src={child.avatar}
            alt={child.title}
          />
          <div className="photo-gradient"/>
          
          {/* Optional badge example */}
          {child.has_debt && (
            <div className="child-badge danger">
              {appStore.tr.debt}
            </div>
          )}
        </div>
        
        {/* Info */}
        <div className="children-card-body">
          <div className="child-name">
            {child.title}
          </div>
          
          <div className="child-meta">
            {appStore.tr.year_born}: {child.year_born}
          </div>
        </div>
        
        {/* Actions */}
        <div className="children-card-actions grid">
          <div className="col-12">
            <Btn
              icon="pi pi-dollar"
              label={appStore.tr.billing}
              className="w-full"
              severity="success"
              onClick={() => {
                clubStore.parent.setProperty(
                  "child_id",
                  child.id
                );
                navigate(`${url_base}/billing`);
              }}
            />
          </div>
          
          <div className="col-6">
            <Btn
              icon="pi pi-chart-line"
              label={appStore.tr.attendance}
              className="w-full"
              outlined
              severity="info"
              onClick={() => {
                clubStore.parent.setProperty(
                  "child_id",
                  child.id
                );
                navigate(`${url_base}/attendance`);
              }}
            />
          </div>
          
          <div className="col-6">
            <Btn
              icon="pi pi-star-fill"
              label={appStore.tr.games}
              className="w-full"
              outlined
              severity="secondary"
              onClick={() => {
                clubStore.parent.setProperty(
                  "child_id",
                  child.id
                );
                navigate(`${url_base}/games`);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default observer(Child)